/**
 * The one spinner (Shared chrome board, turn 7). The same arc as always, but it
 * strokes currentColor and the component decides the colour by size:
 *
 * - page (32)     centred in a container — accent.
 * - inline (20)   beside a line of text — accent.
 * - control (14)  inside a button or a scrim pill — currentColor, so it takes the
 *                 control's own foreground. On media, the wrapping glass pill is
 *                 white-on-dark chrome and the arc rightly follows it.
 *
 * `tone="current"` opts any size out of the accent for the odd host that colours
 * itself. No other colour prop exists; the old `black` flag is gone.
 * Motion is one 0.9s linear rotation (`.s4s-loader` in App.css), which fades
 * instead of spinning under prefers-reduced-motion.
 */
const SIZES = { page: 32, inline: 20, control: 14 } as const;

function Loader({
  size = "page",
  tone,
}: {
  size?: keyof typeof SIZES;
  tone?: "accent" | "current";
}) {
  const px = SIZES[size];
  const resolved = tone ?? (size === "control" ? "current" : "accent");
  return (
    <svg
      data-testid="loader"
      className={"s4s-loader flex-none " + (resolved === "accent" ? "text-accent" : "")}
      width={px}
      height={px}
      viewBox="0 0 38 38"
      xmlns="http://www.w3.org/2000/svg"
      role="status"
      aria-label="Loading"
    >
      <defs>
        <linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="s4s-loader-arc">
          <stop stopColor="currentColor" stopOpacity="0" offset="0%" />
          <stop stopColor="currentColor" stopOpacity=".631" offset="63.146%" />
          <stop stopColor="currentColor" offset="100%" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd" transform="translate(1 1)">
        <path d="M36 18c0-9.94-8.06-18-18-18" stroke="url(#s4s-loader-arc)" strokeWidth="3" />
        <circle fill="currentColor" cx="36" cy="18" r="1.5" />
      </g>
    </svg>
  );
}

export default Loader;
